export default window.AmazonCognitoAdvancedSecurityData;
